import { useSelector } from 'react-redux';
import { selectHasAccessToThirdPartyShare } from '../../CommonSelectors/CommonAreaSelector';

export const useHasAccessToThirdPartyShare = (): boolean => {
  return useSelector(selectHasAccessToThirdPartyShare);
};
